import { withSvgIcon } from './withSvgIcon';

export const MapPinIcon = withSvgIcon(
  <path
    d="m 15.840597,10.340009 c 0.4082,-0.8411206 0.6594,-1.8068614 0.6594,-2.8037414 0,-3.5514 -2.9203,-6.4486 -6.4999993,-6.4486 -3.5797049,0 -6.4999949,2.8972 -6.4999949,6.4486 0,0.99688 0.251208,1.9626208 0.65942,2.8037414 0,0 0.125604,0.28037 0.157005,0.31152 l 3.930605,7.21734 c 0.75697,1.39 2.7519742,1.3916 3.5112442,0.0029 l 3.86252,-7.06447 c 0.0628,-0.12461 0.2198,-0.46729 0.2198,-0.46729 z M 9.9999977,4.3275476 c 1.7898593,0 3.2342993,1.43302 3.2342993,3.20872 0,1.7757004 -1.44444,3.2398714 -3.2342993,3.2398714 -1.7898449,0 -3.2342949,-1.4330209 -3.2342949,-3.2087214 0,-1.7757 1.44445,-3.23987 3.2342949,-3.23987 z"
    fill="currentColor"
  />,
  { viewBox: '0 0 20 20' },
);
